import React from "react";

const items = [
  "🎉 10% OFF First Order — Code: FIRST10",
  "✂️ Free Extra Revision on Premium & Luxury",
  "📦 Book 2 Packages — Get 15% OFF",
  "⚡ Luxury Package at ₹20,500 Only",
  "🏆 500+ Happy Clients Pan India",
  "📞 Free Consultation on WhatsApp",
];

export default function Marquee() {
  const list = [...items, ...items];
  return (
    <div className="bg-[#1a3c5e] text-white overflow-hidden border-y border-[#F7941D]/30" data-testid="offers-marquee">
      <div className="flex animate-marquee whitespace-nowrap py-3">
        {list.map((t, i) => (
          <span key={i} className="px-8 text-sm font-medium">
            {t} <span className="text-[#F7941D] mx-2">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
